export class PromoModelBase {
    id: number;
    points: number;
    constructor();
    constructor(id: number, points: number);
    constructor(id?: number, points?: number){
        if(id) this.id = id;
        if(points || points === 0) this.points = points;
    }
}